module.exports = __webpack_public_path__ + "img/productivity-summary.e6fa493f.webp";